import { connect } from 'react-redux';
import UserSelectorComponent from './../Components/UserSelectorComponent.jsx';
import { auth as authActions } from './../actions';
import { areJiraScansLoading } from './../reducers';
import { auth } from './../helpers';

export const mapStateToProps = (state) => {
  return {
    loading: areJiraScansLoading(state),
    loggedIn: auth.checkAuthenticated(),
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCredentialsChange : (user) =>
      dispatch(authActions.performSignOn(user, ownProps.redirectFunc)),
    onLogoutClick : () => dispatch(authActions.performSignOut())
  };
};

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(UserSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/UserSelectorContainer.jsx